<template>
  <div class="modal" v-if="showModalStatic">
    <div class="modal-content">
      <h2>Solicitud de Trámite</h2>

      <div class="form-group">
        <label for="comentario">Tipo de Trámite:</label>
         <input style="width: 50%;" type="text" id="tipoTramiteStatic" :value="tipoTramiteStatic" readonly>
      </div>

      <div class="form-group">
        <label for="comentario">Comentario del Solicitante:</label>
        <textarea id="comentarioStatic" v-model="comentarioStatic" readonly></textarea>
      </div>

      <div class="form-group">
        <label for="costo">Costo del Trámite:</label>
        <v-icon style="font-size: 20px;">mdi-currency-eur</v-icon>
        <input type="text" style="width: 50%; border:none; padding-left: 0px;" id="costoStatic" :value="costoStatic" readonly>
      </div>

      <div class="form-group">
        <label for="descripcion">Descripción del Trámite:</label>
        <input type="text" style="width: 50%; border:none; padding-left: 0px;" id="descripcionStatic" :value="descripcionStatic" readonly>
      </div>

      <div class="botones">
        <button class="btn-rojo" @click="cancelRequest">Cerrar</button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    comentarioStatic: String,
    costoStatic: String,
    descripcionStatic: String,
    tipoTramiteStatic: String
  },
  data() {
    return {
      showModalStatic: true
    };
  },
  watch: {
    comentarioStatic(newValue) {
      this.comentarioStatic = newValue;
    },
    costoStatic(newValue) {
      this.costoStatic = newValue;
    },
    descripcionStatic(newValue) {
      this.descripcionStatic = newValue;
    },
    tipoTramiteStatic(newValue) {
      this.tipoTramiteStatic = newValue;
    }
  },
  methods: {
    cancelRequest() {
      this.$emit('cancelSendRequest');
    }
  }
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100% !important;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  width: 35%;
  height: auto !important;
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  max-width: 80%;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

textarea,
input[type="text"] {
  width: 100%;
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.botones {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.btn-rojo {
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}

.btn-rojo {
  background-color: red;
  color: white;
}

@media (max-width: 768px) {
  .modal-content {
    max-width: 100%;
  }
}
</style>